import { render, staticRenderFns } from "./CRefinery.vue?vue&type=template&id=630785b0"
import script from "./CRefinery.vue?vue&type=script&lang=js"
export * from "./CRefinery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports